import type { ICellRendererParams } from 'ag-grid-community'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

/**
 * Renders scope name for the control table's Scope column.
 * Matches the layout style of ControlWeightCell (flex, centered) for visual consistency.
 */
export const ControlScopeCell = (params: ICellRendererParams<ControlRow>) => {
  if (!params.data) return null

  return (
    <div className='truncate'>
      <span className='truncate text-body-default'>{params.data.scope?.name ?? '–'}</span>
    </div>
  )
}
